import ProfilePage from "./Pages/ProfilePage";
import React, { useState } from "react";
import { lazy, Suspense } from "react";
import { MGTProviderSetup } from "./MGTProviderSetup";
import "./App.css";
import "../src/assets/Css/custom.css";
import { ThemeProvider } from "./Context/ThemeContext.tsx";
import { BrokenLinkDialogProvider } from "./Context/BrokenLinkDialogContext";
import BrokenLinkDialog from "./Components/BrokenLinkDialog";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";
import { ConfirmDialog } from "primereact/confirmdialog";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RedirectToProfile from "./Pages/RedirectToProfile";
import Sidebar from "./Components/Sidebar.tsx";
import Header from "./Components/Header";
import AuthenticatedRoute from "./Auth/AuthenticatedRoute.tsx";
import Home from "./Pages/Home.tsx";
import Search from "./Pages/Search.tsx";

const Dashboard = lazy(() => import("./Pages/Dashboard"));

const App: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <Router>
      <ThemeProvider>
        <BrokenLinkDialogProvider>
          <MGTProviderSetup />

          {/* Protect everything under AuthenticatedRoute */}
          <AuthenticatedRoute>
            <div className="dashboard">
              <Header onSearch={setSearchQuery} />
              <Sidebar />

              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/profile"
                  element={
                    <Suspense>
                      <Dashboard />
                    </Suspense>
                  }
                />
                <Route path="/profile/:username" element={<ProfilePage />} />
                <Route path="/search" element={<Search searchQuery={searchQuery} />} />
                {/* <Route
                  path="/home"
                  element={<Home searchQuery={searchQuery} />}
                /> */}
              </Routes>

              <BrokenLinkDialog />
              <ConfirmDialog />
            </div>
          </AuthenticatedRoute>
        </BrokenLinkDialogProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
